// Fire-and-forget intent/engagement logging. These signals feed the trends /
// creator / intelligence layer; failures are swallowed so they never affect UX.
const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const SESSION_KEY = 'videbits-session-id';

// A per-tab id so a search and the click that follows it can be stitched into
// one funnel for signed-out visitors (the great majority of traffic). Kept in
// sessionStorage, NOT localStorage or a cookie: it dies with the tab, is never
// sent to a third party and identifies a visit rather than a person, so it
// needs no consent banner. Storage can throw in private mode — never let that
// break a click.
export function getSessionId() {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      // `typeof` guard, not `crypto.randomUUID && ...`: a bare reference throws
      // ReferenceError where the global is absent, which the catch below would
      // swallow — leaving every event without a session id and the funnel
      // unjoinable, silently.
      id = (typeof crypto !== 'undefined' && crypto.randomUUID)
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return null;
  }
}

/**
 * Record one interaction.
 *
 * `rank` is the 1-based position of the clicked result and `resultsCount` the
 * size of the result set it came from. Together with the search event sharing
 * the same session they answer the questions a raw click count cannot: are
 * people clicking the first result or hunting down the page, and which queries
 * return results that nobody wants.
 */
export function logInteraction(
  eventType,
  { tmdbId, mediaType, title, query, rank, resultsCount, source } = {},
) {
  try {
    const token = localStorage.getItem('videbits-token');
    const metadata = {};
    if (rank != null) metadata.rank = rank;
    if (resultsCount != null) metadata.results_count = resultsCount;
    if (source) metadata.source = source;

    fetch(`${API_BASE}/api/interactions`, {
      method: 'POST',
      keepalive: true, // allow the request to outlive a navigation
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({
        event_type: eventType,
        tmdb_id: tmdbId,
        media_type: mediaType,
        title,
        query,
        session_id: getSessionId(),
        metadata: Object.keys(metadata).length ? metadata : undefined,
      }),
    }).catch(() => {});
  } catch {
    /* logging must never throw */
  }
}
